import React, { useState } from "react";

import { classNames, useTranslate } from "helpers/common";

import { SidebarItem } from "./components/SidebarItem";

import { SIDEBAR_ITEMS } from "./consts";
import { SidebarProps } from "./types";

const Sidebar: React.FC<SidebarProps> = (props) => {
  const { openSidebar, onOpenSidebar } = props;
  const [search, setSearch] = useState<string>("");

  const { t } = useTranslate();

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  // Zupčanik s platformskim ekranima je otišao u `admin.autobiz`; ovdje ostaju samo klijentovi
  // moduli. Postavke tvrtke se otvaraju preko korisničkog izbornika gore desno.
  const mainItems = SIDEBAR_ITEMS.filter((item) =>
    item.text.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <div
        className={classNames(
          openSidebar
            ? "absolute left-0 top-14 bottom-0 right-0 z-30 lg:w-64 2xl:w-80 lg:relative lg:top-0 "
            : "w-0  lg:w-16",
          "bg-[#161719] ease-in-out duration-200 "
        )}
      >
        <div className="flex flex-col relative h-full">
          <button
            onClick={onOpenSidebar}
            className="w-8 h-8 rounded-full hidden lg:flex justify-center items-center absolute top-8 -right-4 bg-[#fff] z-30 shadow-2xl"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className={classNames(
                openSidebar ? "transform rotate-180" : "",
                "w-4 h-4 stroke-[#0e101d]"
              )}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.25 4.5l7.5 7.5-7.5 7.5"
              />
            </svg>
          </button>
          <div
            className={classNames(openSidebar ? "flex" : "hidden lg:flex", "flex-col flex-1")}
          >
            <div className="px-3 mb-1">
              <div className="relative text-gray-600 focus-within:text-gray-400 overflow-hidden">
                <span
                  className="absolute inset-y-0 left-0 flex items-center"
                  onClick={onOpenSidebar}
                >
                  <button
                    type="submit"
                    className="z-10 ml-2 focus:outline-none focus:shadow-outline"
                  >
                    <svg
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      className="w-6 h-6 stroke-gray-400"
                    >
                      <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                    </svg>
                  </button>
                </span>
                <input
                  name="search"
                  placeholder={t("admin.sidebar.search")}
                  value={search}
                  onChange={handleSearchChange}
                  className={classNames(
                    openSidebar ? "bg-[#1f2340]" : "bg-[#161719]",
                    " relative block w-full pl-12 text-sm appearance-none rounded h-10 focus:outline-none focus:shadow-outline"
                  )}
                />
              </div>
            </div>
            <div className={classNames(openSidebar ? "overflow-y-auto" : "", "flex-1")}>
              {mainItems.map((item, index) => {
                return (
                  <SidebarItem
                    key={index}
                    text={item.text}
                    icon={item.icon}
                    route={item.route}
                    childItems={item.childItems}
                    openSidebar={openSidebar}
                  />
                );
              })}
            </div>

          </div>
        </div>
      </div>
    </>
  );
};
export default Sidebar;
